import { cva } from 'cva'

export const toastVariants = cva({
  base: [
    'mx-auto w-[calc(100vw-32px)] mobile:min-w-[360px] tablet:max-w-[480px]',
    'group pointer-events-auto relative flex',

    'items-center justify-between space-x-[5px] overflow-hidden rounded-lg p-5',

    [
      'shadow-lg transition-all',
      'data-[swipe=cancel]:translate-x-0',
      'data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)]',
      'data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]',
      'data-[swipe=move]:transition-none',
      'data-[swipe=end]:animate-out',

      'data-[state=open]:animate-in',
      'data-[state=closed]:animate-out',
      'data-[state=closed]:fade-out-80',
      'data-[state=closed]:slide-out-to-right-full',
      'data-[state=open]:slide-in-from-top-full',
      'data-[state=open]:sm:slide-in-from-bottom-full',
    ],
  ],
  variants: {
    variant: {
      default: 'bg-gray-900 opacity-70 text-white',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})
